import { makeAutoObservable } from "mobx";
import NotificationStore from "@stores/NotificationStore";
import AccountStore, { ISerializedAccountStore } from "@stores/AccountStore";
import OverviewStore from "./OverviewStore";
import SettingsStore from "./SettingsStore";
import PricesStore from "./PricesStore";

export interface ISerializedRootStore {
  accountStore?: ISerializedAccountStore;
}

export default class RootStore {
  public accountStore: AccountStore;
  public overviewStore: OverviewStore;
  public notificationStore: NotificationStore;
  public settingsStore: SettingsStore;
  public pricesStore: PricesStore;

  constructor(initState?: ISerializedRootStore) {
    this.notificationStore = new NotificationStore(this);
    this.accountStore = new AccountStore(this, initState?.accountStore);
    this.overviewStore = new OverviewStore(this);
    this.settingsStore = new SettingsStore(this);
    this.pricesStore = new PricesStore(this);
    makeAutoObservable(this);
  }

  serialize = (): ISerializedRootStore => ({
    accountStore: this.accountStore.serialize(),
  });
}
